import { Menu } from '@mui/icons-material';
import { useTheme } from '@mui/material';
import { tertiaryHoverSx } from '../../styles/Global.style';

export const Burger = () => {
  const theme = useTheme();

  return <Menu fontSize="large" sx={tertiaryHoverSx(theme)} />;
};
